import { render } from "./hero.vue?vue&type=template&id=dc9b2d46&scoped=true"
import script from "./hero.vue?vue&type=script&lang=js"
export * from "./hero.vue?vue&type=script&lang=js"

import "./hero.vue?vue&type=style&index=0&id=dc9b2d46&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-dc9b2d46"

export default script